export const formatDelegationTaskSteps = (value: any) => {
  const text = String(value || "").replace(/\r\n/g, "\n").trim();
  if (!text) return "";

  return text
    .split(/\n+/)
    .flatMap((line) => line.split(/\s*(?=(?:\d+[.)]|[-*•])\s+)/g))
    .flatMap((line) => line.split(/\s*;\s*/g))
    .map((line) => line.replace(/^\s*(?:\d+[.)]|[-*•])\s*/, "").trim())
    .filter(Boolean)
    .join("\n");
};
